import { makeAutoObservable } from 'mobx';
import {api, t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {successAlert, errorAlert} from 'shared/tools';
import {BillingSubscription} from 'main/stores/billing';
import _ from 'lodash';

class BillingDetailsState {
  subscription;
  editSubscription;
  editContactDetailsModalOpen = false;
  cancelPayrollModalOpen = false;
  cancelSubscriptionModalOpen = false;
  reactivatingSubscription = false;
  selectedEmails = [];

  errors = {};

  constructor(store) {
    makeAutoObservable(this);

    this.store = store;
  }

  async load() {
    await this.store.load();

    this.subscription = this.store.getBillingSubscription();
  }

  openCancelPayrollModal() {
   this.cancelPayrollModalOpen = true;
  }

  closeCancelPayrollModal() {
   this.cancelPayrollModalOpen = false;
  }

  openCancelSubscriptionModal() {
   this.cancelSubscriptionModalOpen = true;
  }

  closeCancelSubscriptionModal() {
   this.cancelSubscriptionModalOpen = false;
  }

  openEditContactDetailsModal() {
    this.editSubscription = new BillingSubscription(this.subscription);
    this.selectedEmails = this.editSubscription.ccEmails.slice();
    this.editContactDetailsModalOpen = true;
  }

  closeEditContactDetailsModal() {
    this.editContactDetailsModalOpen = false;
  }

  async notifyPayroll() {
    const {status} = await api.post(endpoints.COMPANY_REQUEST_PAYROLL_CANCELLATION);

    if (status === 201) {
      successAlert(t('company_settings.billing.cancel_subscription.Our team will contact you shortly'));
      this.closeCancelPayrollModal();
    }
  }

  async requestSubscriptionCancellation() {
    const {status} = await api.post(endpoints.COMPANY_REQUEST_SUBSCRIPTION_CANCELLATION);

    if (status === 201) {
      successAlert(t('company_settings.billing.cancel_subscription.Our team will contact you shortly'));
      this.closeCancelSubscriptionModal();
    }
  }

  async retrySubscription() {
    const {model} = await this.store.patch(
      this.subscription.link('retry'),
      types.BILLING.SUBSCRIPTION
    );

    if (model) {
      this.subscription = new BillingSubscription(model);
      successAlert(t('company_settings.billing.retry_subscription.Payment succeeded.'));
    } else {
      errorAlert(t('company_settings.billing.retry_subscription.Payment failed. Please contact our support team for further assistance.'));
    }
  }

  onCcEmailsChange(e) {
    if (e.action === 'add') {
      this.addCcEmail(e.value);
    } else if (e.action === 'remove') {
      this.removeCcEmail(e.value);
    }
  }

  addCcEmail(email) {
    this.selectedEmails.push(email);
  }

  removeCcEmail(email) {
    _.remove(this.selectedEmails, (existingEmail) => existingEmail === email);
  }

  async saveContactDetails() {
    this.editSubscription.ccEmails = this.selectedEmails;
    const {errors, model} = await this.store.patch(
      endpoints.BILLING.UPDATE_CONTACT_DETAILS,
      types.BILLING.SUBSCRIPTION,
      this.editSubscription
    );

    if (model) {
      this.subscription.update(model);
      this.closeEditContactDetailsModal();
    }
    this.errors = errors;
  }

  async reactivateSubscription() {
    this.reactivatingSubscription = true;
    const {model} = await this.store.patch(
      this.subscription.link('reactivate'),
      types.BILLING.SUBSCRIPTION
    );
    this.reactivatingSubscription = false;

    if (model) {
      this.subscription = new BillingSubscription(model);
      successAlert(t('company_settings.billing.reactivate_subscription.Subscription reactivated.'));
    } else {
      errorAlert(t('company_settings.billing.reactivate_subscription.Reactivation failed. Please contact our support team for further assistance.'));
    }
  }

  get subscriptionIsActive() {
    return !this.subscription.hasLink('reactivate');
  }
}

export default BillingDetailsState;
